// Referral attribution: capture ?ref=METRO-XXXXXX from URL into localStorage
// so it survives signup → checkout. Server-side is the source of truth for redemption.

const KEY = "metroshine_ref_v1";
const REFERRAL_CODE_RE = /^METRO-[A-Z2-9]{6}$/;

type StoredRef = { code: string; capturedAt: number; path: string };

export const captureReferralFromUrl = () => {
  if (typeof window === "undefined") return;
  try {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get("ref");
    if (!raw) return;
    const code = raw.trim().toUpperCase();
    if (!REFERRAL_CODE_RE.test(code)) return;
    // Don't overwrite an existing capture (preserve first-touch attribution)
    if (localStorage.getItem(KEY)) return;
    const payload: StoredRef = { code, capturedAt: Date.now(), path: window.location.pathname };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
};

export const getStoredReferralCode = (): string | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredRef;
    if (!parsed?.code || !REFERRAL_CODE_RE.test(parsed.code)) return null;
    // 30-day window
    if (Date.now() - parsed.capturedAt > 30 * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.code;
  } catch {
    return null;
  }
};

export const clearStoredReferralCode = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

export const isValidReferralCodeFormat = (code: string) => REFERRAL_CODE_RE.test(code);
